<lib-site-setup-navbar
  [stepNumber]="StepNumberEnum.SoftwareLicenseAgreement"
  class="w-full"
  [loggedInUser]="vm().currentUser"
  [isNewModalDesign]="true"
  [hasBackButton]="false"
  [hasUserProfile]="vm().contract?.data?.contractStatus === ContractStatus.INITIATED"
></lib-site-setup-navbar>

<div
  class="mt-2 flex flex-wrap gap-1 font-poppins text-[24px] font-medium leading-[34px] tracking-[-0.7px] text-[#595959] xs:text-[30px] xs:leading-[45px]"
>
  <span>{{ 'site_setup_contract_title_part1' | translate }}</span
  ><span
    class="text-background border-0 border-solid border-primary-blue"
    [class.border-r-2]="vm().contract?.data?.contractStatus === ContractStatus.INITIATED"
    >{{ 'site_setup_contract_title_part2' | translate }}</span
  >
</div>

@if (vm().contract?.data?.contractStatus === ContractStatus.INITIATED) {
  <div class="mt-5 flex flex-col">
    <div class="flex flex-col gap-3 xs:flex-row xs:justify-between xs:gap-0">
      <h2 class="typo-h3-medium flex items-center font-poppins leading-tight text-[#444444]">
        {{ 'site_setup_contract_licensing_agreement' | translate }}
        <svg-icon size="sm" class="ml-2" [key]="'px-16-info'" [libUiTooltip]="titleTooltip" tooltipPosition="right-bottom"></svg-icon>

        <ng-template #titleTooltip>
          <div class="typo-h5-book whitespace-pre-wrap">
            {{ 'site_setup_form_title_tooltip' | translate }}
          </div>
        </ng-template>
      </h2>
      <a
        class="typo-h7-semibold flex items-center gap-x-2 self-start rounded-xl bg-background-light-blue px-4 py-2 text-primary-blue"
        target="_blank"
        rel="noopener noreferrer"
        [href]="'https://secure.ffd.ai/tutorials/install_flow/license-agreement-template.pdf'"
      >
        <svg-icon size="sm" class="text-primary-blue" width="16px" height="16px" [key]="'px-16-file'"></svg-icon>
        {{ 'site_setup_contract_licensing_download_template_button' | translate }}
      </a>
    </div>
    <!-- <p class="mt-2 text-h4 font-light">{{ 'site_setup_contract_proceed_authorized_person' | translate }}</p> -->

    <!-- <section class="mt-10">
      <h4 class="flex items-center text-h4 font-bold">
        {{ 'site_setup_contract_authorized_to_sign' | translate }}
        <svg-icon
          size="sm"
          class="ml-2 text-primary-blue"
          [key]="'px-16-info'"
          [libUiTooltip]="signerTooltip"
          tooltipPosition="right-bottom"
        ></svg-icon>

        <ng-template #signerTooltip>
          <div class="typo-h5-book whitespace-pre-wrap">
            {{ 'site_setup_form_signer_tooltip' | translate }}
          </div>
        </ng-template>
      </h4>

      <form [formGroup]="isAuthorizedForm">
        <div class="mt-3 flex items-center">
          <lib-radio-button formControlName="isAuthorized"></lib-radio-button>
          <span class="ml-2 text-h4 font-light">{{ 'site_setup_contract_confirm_authorized' | translate }}</span>
        </div>
        <div class="mt-3 flex items-center">
          <lib-radio-button formControlName="isNotAuthorized"></lib-radio-button>
          <span class="ml-2 text-h4 font-light">{{ 'site_setup_contract_prefer_authorized_signer' | translate }}</span>
        </div>
      </form>
    </section>

    @if (isAuthorizedForm.controls.isAuthorized.value || isAuthorizedForm.controls.isNotAuthorized.value) { -->
    <lib-license-agreement-form [showSignerEmail]="false" [showAuthorizedCheckbox]="true"></lib-license-agreement-form>

    <div class="mt-10 flex gap-3">
      <button class="btn-secondary flex h-10 w-full items-center justify-center" type="button" (click)="onBack()">
        {{ 'site_setup_contract_back' | translate }}
      </button>
      <button class="btn-primary flex h-10 w-full items-center justify-center" type="button" (click)="onSubmitLicenseAgreement()">
        {{ 'site_setup_contract_continue' | translate }}
      </button>
    </div>
    <!-- } -->
  </div>
}

@if (vm().contract?.data?.contractStatus === ContractStatus.SIGNED) {
  <div class="mt-5 flex h-full flex-col gap-5">
    <svg-icon size="4xl" key="px-96-success" class="my-4 self-center"></svg-icon>

    <div class="typo-h5-light font-poppins font-light leading-[130%] text-text-light">
      {{ 'site_setup_form_signed_success' | translate }} {{ 'site_setup_form_signed_success_agreement_signed' | translate }}
      {{ 'site_setup_form_signed_success_description1' | translate }}
    </div>
    <div class="typo-h5-medium text-center font-poppins font-medium leading-[130%] text-text-primary">
      {{ vm().contract?.data?.signatoryEmail || vm().currentUser?.email }}
    </div>
    <div class="typo-h5-light font-poppins font-light leading-[130%] text-text-light">
      {{ 'site_setup_form_signed_success_description2' | translate }}
      <button class="font-semibold text-primary-blue" (click)="onDownloadClick()">
        {{ 'site_setup_form_signed_success_description_link' | translate }}
      </button>
    </div>

    <button class="btn-primary mt-4 flex h-10 w-full items-center justify-center" type="button" type="button" (click)="onNextClick()">
      {{ 'site_setup_form_signed_success_button' | translate }}
    </button>
  </div>
}

@if (vm().contract?.data?.contractStatus === ContractStatus.SENT_TO_SIGNATORY) {
  <div class="flex h-full flex-col items-center">
    <svg-icon size="3xl" key="px-64-message" class="my-10"></svg-icon>

    <h1 class="mb-10 whitespace-pre-wrap text-center text-h1 font-semibold">
      {{ 'site_setup_form_sent_success_title' | translate }}
    </h1>

    <h4 class="text-center text-h4 font-light text-text-secondary">
      {{ 'site_setup_form_sent_success_description1' | translate }}
      <span class="font-semibold">{{ vm().contract?.data?.signatoryEmail }}</span>
    </h4>
    <h4 class="mb-10 text-center text-h4 font-light text-text-secondary">
      <span class="font-semibold">{{ 'site_setup_form_sent_success_description2' | translate }}</span>
      {{ 'site_setup_form_sent_success_description3' | translate }}
    </h4>
    <button class="btn-text" type="button" (click)="openInfoModal()">
      {{ 'site_setup_form_sent_success_button' | translate }}
    </button>
  </div>
}
